<template>
    <v-container fluid class="ma-0 pa-0">
        <v-card class="fill-height mt-0 pt-0" tile elevation="0">
            <ShiftToolbar
                :moduleColor="moduleColor"
                :selectedDate="selectedDate"
                :shiftPeriod="shiftPeriod"
                :loading="loading.driverShifts"
                :menuItems="shiftsToolbarMenuItems"
                :search="search"
                :selectedRegion="selectedRegion"
                @update-search="updateSearch"
                @update-region="updateSelectedRegion"
                @refresh="getDriverShifts"
                @update-date="updateSelectedDate"
                @update-shift-period="updateShiftPeriod"
            />
            <v-container
                class="shifts-container"
                style="max-height: calc(100vh - 260px); overflow-y: auto;"
            >
                <ShiftCard
                    v-for="(item, index) in filteredDriverShifts"
                    :key="item.ShiftDetail"
                    :shift="item"
                    :shiftIndex="index"
                    :terminals="terminals"
                />
                <v-alert
                    v-if="!filteredDriverShifts.length"
                    type="info"
                    prominent
                    border="left"
                    class=""
                >
                    <template #prepend>
                        <v-icon color="upt" x-large left class="pulsing">
                            mdi-alert-circle
                        </v-icon>
                    </template>
                    No Shifts Found for Selected Date or search query: "{{
                        search
                    }}"
                </v-alert>
            </v-container>
        </v-card>
        <viewB
            v-if="dialogs.planB"
            :openViewB="dialogs.planB"
            :data_b="planBData"
            @close="dialogs.planB = false"
        ></viewB>
        <confirm-dialogue ref="confirmAutoAssign"></confirm-dialogue>
    </v-container>
</template>

<script>
import axios from 'axios';

import ShiftToolbar from './ShiftToolbar.vue';
import ShiftCard from './ShiftCard.vue';

import viewB from '../../Modals/Dispatch/Dispatch/ViewPlanB.vue';
import ConfirmDialogue from './../../Modals/ConfirmDialogue.vue';

export default {
    name: 'Shifts',
    components: { ShiftToolbar, ShiftCard, viewB, ConfirmDialogue },
    props: ['moduleColor'],
    data() {
        return {
            loading: {
                driverShifts: true
            },
            dialogs: {
                planB: false
            },
            planBData: [],
            shiftHeader: null,
            driverShifts: [],
            terminals: [],
            shiftsToolbarMenuItems: [
                {
                    title: 'Get Dispatch Report',
                    action: () => {
                        this.getDispatchReport(0 , 0);
                    },
                    icon: 'mdi-file-document',
                    view: 0,
                },
                {
                    title: 'Get No Allocation Report',
                    action: () => {
                        this.getDispatchReport(0, 1);
                    },
                    icon: 'mdi-file-document',
                    view: 0,
                },
                {
                    title: 'Auto assign',
                    action: () => {
                        this.confirmAutoAssign(); //Done
                    },
                    icon: 'mdi-auto-fix',
                    view: this.$store.state.currentUser.id == 106 ||  this.$store.state.currentUser.id == 39 || this.$store.state.currentUser.id > 197 ? 0 : 1
                },
                {
                    title: 'Auto Fill',
                    action: () => {
                        this.confirmAutoFill(); //Done
                    },
                    icon: 'mdi-basket-fill',
                    view: this.$store.state.currentUser.id == 106 ||  this.$store.state.currentUser.id == 39 || this.$store.state.currentUser.id > 197 ? 0 : 1
                },
                {
                    title: 'Auto Fill Without HomeLoad',
                    action: () => {
                        this.confirmAutoFillWithoutHomeload(); //Done
                    },
                    icon: 'mdi-basket-fill',
                    view: this.$store.state.currentUser.id == 106 ||  this.$store.state.currentUser.id == 39 || this.$store.state.currentUser.id > 197 ? 0 : 1
                },
                {
                    title: 'Plan B',
                    action: () => {
                        this.getDispatchPlanB();
                    },
                    icon: 'mdi-alpha-b-circle',
                    view: this.$store.state.currentUser.id == 106 ||  this.$store.state.currentUser.id == 39 || this.$store.state.currentUser.id > 197 ? 0 : 1
                },
                {
                    title: 'View Plan B',
                    action: () => {
                        this.updateDispatchPlanB();
                    },
                    icon: 'mdi-compare',
                    view: this.$store.state.currentUser.id == 106 ||  this.$store.state.currentUser.id == 39 || this.$store.state.currentUser.id > 197 ? 0 : 1
                },
                {
                    title: 'Open Shift Comments',
                    action: () => {
                        this.openShiftComments();
                    },
                    icon: 'mdi-comment',
                    view: 0,
                },
            ],
            // today in yyyy-mm-dd format
            currentDateTime: new Date().toString(),
            today: new Date().toLocaleDateString('en-CA'),
            selectedDate: null,
            shiftPeriod: 'AM', // AM or PM,
            search: '',
            selectedRegion: 0,
            hasMounted: false // New flag to track if mounted
        };
    },
    computed: {
        
        ETAHrsUpdate: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios

                // .get('/ftp-readings/update/orders')
                .get('recalculate/eta/hrs/' + this.shiftHeader.ShiftId)
                .then(response => {
                    // this.data_b = response.data;
                    console.log(response);
                    str.state.isLoading = false;
                    // this.openViewB = true;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        filteredDriverShifts() {
            // Early return if no filtering is required
            if (!this.search && this.selectedRegion === 0) {
                return this.driverShifts;
            }

            const search = this.search.toLowerCase(); // Normalize search once
            const hasSearch = !!this.search; // Boolean flag for search presence
            const hasRegion = this.selectedRegion > 0; // Boolean flag for region filtering

            return this.driverShifts.filter(item => {
                // Region filter
                if (
                    hasRegion &&
                    item.yard.PrincipalRegion !== this.selectedRegion
                ) {
                    return false; // Skip if region doesn't match
                }

                // Search filter (skip if no search)
                if (hasSearch) {
                    const driverName = item.driver.Name.toLowerCase();
                    const yardName = item.yard.Yard.toLowerCase();
                    const shiftDetail = item.ShiftDetail.toString();

                    // Check if search matches driver name, yard name, or shift detail
                    if (
                        driverName.includes(search) ||
                        yardName.includes(search) ||
                        shiftDetail.includes(search)
                    ) {
                        return true;
                    }

                    // Check orders for terminal or station match
                    if (
                        item.orders.some(order => {
                            const terminalName = order.terminal.TerminalName.toLowerCase();
                            const stationName = order.station.Name.toLowerCase();
                            return (
                                terminalName.includes(search) ||
                                stationName.includes(search)
                            );
                        })
                    ) {
                        return true;
                    }

                    return false; // If no search matches, skip this shift
                }

                return true; // Include the shift if no search is applied
            });
        }
    },
    
    watch: {
        '$store.state.removeOrderShift': async function () {
             if (this.$store.state.removeOrderShift > 0) {
                //  const idx = await this.getIndex(this.$store.state.removeOrderShift);
                //  console.log('Here Back Reload', this.filteredDriverShifts[idx].ShiftDetail) ;
                //  const orders = await this.getOrdersByShiftDetail('just-refresh');
                //  console.log('Here');
                //  this.filteredDriverShifts[idx].orders = orders;
                //  console.log(this.filteredDriverShifts[idx].orders)
                this.getDriverShifts();
                 this.$store.state.removeOrderShift = 0;
            }
        }
    },
    mounted() {
        // Set default shiftPeriod and selectedDate on mount
        this.shiftPeriod = new Date().getHours() >= 12 ? 'PM' : 'AM';
        this.selectedDate = this.today;
        // Set mounted flag to true after initial values are set
        this.hasMounted = true;
        this.getDriverShifts();
    },
    methods: {
        getIndex: async function(shift){
                return this.driverShifts.findIndex(x => {
                     return x.ShiftDetail = shift;
                 });
        },  
        async getDriverShifts() {
            this.loading.driverShifts = true;
            await axios
                .post('v2/driver-shifts/filter', {
                    shiftDate: this.selectedDate,
                    shiftPeriod: this.shiftPeriod
                })
                .then(response => {
                    this.$store.state.shiftId = response.data.shiftHeader;
                    this.shiftHeader = response.data.shiftHeader;
                    this.driverShifts = response.data.driverShifts;
                    this.terminals = response.data.terminals;
                    this.$emit('newShiftHeader', this.shiftHeader);
                })
                .catch(function(error) {
                    console.log(error);
                })
                .finally(() => {
                    this.loading.driverShifts = false;
                });
        },
        // Called when user changes the selected date
        updateSelectedDate(newDate) {
            this.selectedDate = newDate;
            if (this.hasMounted) {
                this.getDriverShifts();
            }
        },
        // Called when user changes the shift period
        updateShiftPeriod(newPeriod) {
            this.shiftPeriod = newPeriod;
            if (this.hasMounted) {
                this.getDriverShifts();
            }
        },
        updateSearch(newSearch) {
            this.search = newSearch;
        },
        updateSelectedRegion(newRegion) {
            this.selectedRegion = newRegion;
            this.$emit('regions', newRegion)
        },
        openShiftComments() {
            console.log('Open Shift Comments');
        },
        cleanDispatch: function ()
        {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('clean-dispatch/' + this.shiftHeader.ShiftId)
                .then(response => {
                    console.log(response);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        setDispatchAutoAssign() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('auto-dispatch/' + this.shiftHeader.ShiftId)
                .then(response => {
                    this.getDriverShifts();
                    console.log(response);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        setDispatchAutoFill() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('fill-dispatch/' + this.shiftHeader.ShiftId)
                .then(response => {
                    this.getDriverShifts();
                    console.log(response);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        
        setDispatchAutoFillWithOutHomeLoad() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('fill-dispatch/without/homeload/' + this.shiftHeader.ShiftId)
                .then(response => {
                    this.getDriverShifts();
                    console.log(response);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        setDispatchAutoFillWithOutHomeLoadPlanB() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('dispatch-plan-b/fill-dispatch/without/homeload/' + this.shiftHeader.ShiftId)
                .then(response => {
                    this.planBData = response.data;
                    str.state.isLoading = false;
                    this.dialogs.planB = true;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        getDispatchPlanB() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('dispatch-plan-b/' + this.shiftHeader.ShiftId)
                .then(response => {
                    this.middleLoads();
                    // str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        middleLoads: function()
        {
            this.$store.state.isLoading = true;
            axios
                .get('dispatch-plan-b/fill-dispatch/' + this.shiftHeader.ShiftId)
                .then(response => {
                    this.setDispatchAutoFillWithOutHomeLoadPlanB();
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });  
        },
        updateDispatchPlanB() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('dispatch-plan-b/show/' + this.shiftHeader.ShiftId)
                .then(response => {
                    this.planBData = response.data;
                    console.log(response);
                    str.state.isLoading = false;
                    this.dialogs.planB = true;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        checkForEleosCurrent: async function(shiftDetail) {
            let resp;
            await axios
                .get('shift-detail/eleos-current-shift/' + shiftDetail)
                .then(response => {
                    console.log('checkForEleosCurrent: ', response.data);
                    resp = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });

            return resp;
        },
        onEditOrderClose: async function(shDetail) {
            console.log('onEditOrderClose', shDetail);
            let index = this.filteredDriverShifts.findIndex(x => {
                return x.ShiftDetail == shDetail;
            });
            console.log('onEditOrderClose', index);
            let eleosCurrent = await this.checkForEleosCurrent(shDetail);

            await this.loadOrderShift(shDetail, index, 'onEditOrderClose');
            console.log(this.filteredDriverShifts[index].SentMailCounter);
            if (
                this.filteredDriverShifts[index].SentMailCounter > 0 &&
                this.filteredDriverShifts[index].DriverEleosApp == 1 &&
                eleosCurrent == 1
            ) {
                console.log('Dentro del if',shDetail ,index);
                let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                    shDetail,
                    index
                );
                await this.getCurrentShiftInfo(
                    shDetail,
                    index,
                    newShiftInfoDispatch
                );
            }
        },
        getCurrentShiftInfo: async function(
            shDetail,
            index,
            newShiftInfoDispatch
        ) {
            let emailCounter = this.filteredDriverShifts[index].SentMailCounter;

            if (emailCounter > 0) {
                var str = this.$store;
                str.state.isLoading = true;
                await axios
                    .get('shift-diff-checker/current-info/' + shDetail, {
                        headers: {
                            Authorization: 'Bearer ' + str.state.token
                        }
                    })
                    .then(async response => {
                        let currentShiftInfoDispatch = response.data;
                        console.log(
                            'CurrentShiftInfoDispatch',
                            currentShiftInfoDispatch
                        );
                        str.state.isLoading = false;
                        await this.getProductsByOrder(
                            emailCounter,
                            index,
                            newShiftInfoDispatch,
                            currentShiftInfoDispatch
                        );
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                        str.state.isLoading = false;
                    });
            } else {
                console.log(emailCounter);
                await this.getProductsByOrder(
                    emailCounter,
                    index,
                    newShiftInfoDispatch,
                    {}
                );
            }
        },
        getProductsByOrder: async function(
            emailCounter,
            index,
            newShiftInfoDispatch,
            currentShiftInfoDispatch
        ) {
            var str = this.$store;

            console.log('Dentro de getProductsByOrder', newShiftInfoDispatch);
            for (let ord of newShiftInfoDispatch.ordersShiftData) {
                //console.log(ord.generalOrderData.OrderID)

                await axios
                    .get('order-detail/order/' + ord.generalOrderData.OrderID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        let productsByOrder = response.data.data;
                        console.log('productsByOrder', productsByOrder);
                        ord.orderProductData = [];
                        for (let prd of productsByOrder) {
                            let {
                                Product,
                                ProductID,
                                ProductCode,
                                DispatchedQuantity
                            } = prd;
                            ord.orderProductData.push({
                                Product,
                                ProductID,
                                ProductCode,
                                DispatchedQuantity
                            });
                        }

                        // Ordenamiento tipo burbuja por ProductID
                        let l = ord.orderProductData.length;
                        let aux;

                        for (let i = 1; i < l; i++) {
                            for (let prd = 0; prd < l - i; prd++) {
                                if (
                                    ord.orderProductData[prd].ProductID >
                                    ord.orderProductData[prd + 1].ProductID
                                ) {
                                    aux = ord.orderProductData[prd];
                                    ord.orderProductData[prd] =
                                        ord.orderProductData[prd + 1];
                                    ord.orderProductData[prd + 1] = aux;
                                }
                            }
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            }

            if (emailCounter > 0) {
                this.generateDiffs(
                    index,
                    newShiftInfoDispatch,
                    currentShiftInfoDispatch
                );
            } else {
                console.log('No se ha hecho el primer envío.');
            }
            console.log('NewShiftInfo', newShiftInfoDispatch);
        },
        buildNewShiftInfoDispatch: function(shDetail, index) {
            console.log('buildNewShiftInfoDispatch',shDetail, index);
            let newShiftInfoDispatch = {};
            let shift = this.filteredDriverShifts[index];
            console.log(shift);
            // Preparation of the new shift info data
            
            let sh = {
                Driver: shift.driver?.Name,
                DriverID: shift.driver?.DriverID,
                ShiftDate: shift.shift_header?.Date,
                Shift: shift.shift_header?.Shift,
                ShiftDetail: shift.ShiftDetail,
                Truck: shift.truck?.Truck,
                TruckID: shift.truck?.TruckID,
                Trailer: shift.trailer?.Trailer,
                TrailerID: shift.trailer?.TrailerId,
                ReplacementUnit: shift.ReplacementUnit,
                Yard: shift.yard?.Yard,
                TruckYard: shift.yard?.YardId,
                SentMailCounter: 0,
                DriverEleosApp: shift.DriverEleosApp
            };
            

            newShiftInfoDispatch['generalShiftData'] = sh;
            newShiftInfoDispatch['ordersShiftData'] = [];

            for (let ord of this.filteredDriverShifts[index].orders) {
                let od = {
                    Customer: ord.customer?.Name,
                    CustomerID: ord.Customer,
                    Supplier: ord.supplier?.Supplier,
                    SupplierID: ord.Supplier,
                    LoadNum: ord.LoadNum,
                    LoadNumOrd: ord.LoadNumOrd,
                    LoadingNumber: ord.LoadingNumber,
                    OrderID: ord.OrderID,
                    OrderStatus: ord.OrderStatus,
                    PreloadOrderID: ord.PreloadOrderID,
                    ShipTo: ord.ShipTo,
                    SpecialInstructions: ord.SpecialInstructions,
                    StationID: ord.Station,
                    Station: ord.StationName,
                    StationAddress: ord.station?.Address,
                    StationCity: ord.StationCity,
                    TerminalID: ord.Terminal,
                    Terminal: ord.TerminalName,
                    TerminalAddress: ord.terminal?.Address,
                    TerminalColor:ord.Color
                };

                newShiftInfoDispatch['ordersShiftData'].push({
                    generalOrderData:od,
                    orderProductData: []
                });
            }

            return newShiftInfoDispatch;
        },
        loadOrderShift: async function(
            shiftDetail,
            index,
            invocationOrigin = ''
        ) {
            // this.filteredDriverShifts[index].View = false;
            this.filteredDriverShifts[index].orders.length = 0;
            await axios
                .post('order/shift/new/' + shiftDetail, {})
                .then(async response => {
                    console.log(response.data);
                    this.filteredDriverShifts[index].orders = response.data;

                    if (
                        invocationOrigin != 'updateActiveOrder' ||
                        invocationOrigin !=
                            'onFinalizeCurrentOrderInProgressClose' ||
                        invocationOrigin != 'endOrder' ||
                        invocationOrigin != 'onEditOrderClose' ||
                        invocationOrigin != 'onPreloadOrderToShiftClose' ||
                        invocationOrigin != 'onShiftSummaryClose' ||
                        invocationOrigin != 'preloadOrderInterface' ||
                        invocationOrigin != 'unpreloadOrderInterface' ||
                        invocationOrigin != 'updateFor' ||
                        invocationOrigin != 'setShortLoad'
                    ) {
                        this.AlterOrders = false;
                        this.idxAdd = 0;
                        this.idxRemv = 0;
                    }

                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getDispatchReport: function(excel, noAllocation) {
            console.log('Printing...' + this.$store.state.shiftId);
            this.$store.state.isLoading = true;
            let str = this.$store;

            let params = {
                        shift_header: this.$store.state.shiftId,
                        excel: excel,
                        no_allocation: noAllocation
                    };
            if (this.$store.state.shiftId != null) {
                axios({
                    url: 'shift-detail/dispatch-report',
                    method: 'post',
                    data: params,
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        if (excel == true) {
                            if (noAllocation) {
                                link.setAttribute(
                                    'download',
                                    'No Allocation Report.xlsx'
                                );
                            } else {
                                link.setAttribute(
                                    'download',
                                    'Dispatch Report.xlsx'
                                );
                            }
                        } else {
                            if (noAllocation) {
                                link.setAttribute(
                                    'download',
                                    'No Allocation Report.pdf'
                                );
                            } else {
                                link.setAttribute(
                                    'download',
                                    'Dispatch Report.pdf'
                                );
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function(error) {
                        str.state.isLoading = false;
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }

            console.log(this.$store.state.isLoading);
        },
        
        async confirmAutoAssign() {
            const ok = await this.$refs.confirmAutoAssign.show({
                title: 'Are you sure to run Auto Assign',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.setDispatchAutoAssign();
            }
        },
        async confirmAutoFill() {
            const ok = await this.$refs.confirmAutoAssign.show({
                title: 'Are you sure to run Auto Fill',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.setDispatchAutoFill();
            }
        },
        async confirmAutoFillWithoutHomeload() {
            const ok = await this.$refs.confirmAutoAssign.show({
                title: 'Are you sure to run Auto Fill Without HomeLoad',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.setDispatchAutoFillWithOutHomeLoad();
            }
        },
        
        generateDiffs: function(
            index,
            newShiftInfoDispatch,
            currentShiftInfoDispatch
        ) {
            // Current variables
            const currGenShData = currentShiftInfoDispatch.generalShiftData;
            const currOrdShData = currentShiftInfoDispatch.ordersShiftData;

            // New variables
            const newGenShData = newShiftInfoDispatch.generalShiftData;
            const newOrdShData = newShiftInfoDispatch.ordersShiftData;

            let matchingOrders = [];

            // Diffs at Shift Level
            let diffDriver = currGenShData.DriverID != newGenShData.DriverID;
            let diffTruck = currGenShData.TruckID != newGenShData.TruckID;
            let diffTrailer = currGenShData.TrailerID != newGenShData.TrailerID;
            let diffReplUnit =
                currGenShData.ReplacementUnit != newGenShData.ReplacementUnit;

            let thereAreDiffs =
                diffTruck || diffTrailer || diffReplUnit || diffDriver;

            // Diffs at Order Level
            for (let newOrd = 0; newOrd < newOrdShData.length; newOrd++) {
                for (
                    let currOrd = 0;
                    currOrd < currOrdShData.length;
                    currOrd++
                ) {
                    if (
                        newOrdShData[newOrd].generalOrderData.OrderID ==
                        currOrdShData[currOrd].generalOrderData.OrderID
                    ) {
                        let newOrderData =
                            newOrdShData[newOrd].generalOrderData;
                        let currOrderData =
                            currOrdShData[currOrd].generalOrderData;

                        let newPrdData = newOrdShData[newOrd].orderProductData;
                        let currPrdData =
                            currOrdShData[currOrd].orderProductData;

                        newOrdShData[newOrd].MatchingProductData = [];
                        newOrdShData[newOrd].OnlyNewProductData = [];

                        // Order Diffs
                        newOrderData.orderDiffs = {};
                        newOrderData.orderDiffs.diffLoadNum =
                            newOrderData.LoadNum != currOrderData.LoadNum;
                        newOrderData.orderDiffs.diffLoadNumOrd =
                            newOrderData.LoadNumOrd != currOrderData.LoadNumOrd;
                        newOrderData.orderDiffs.diffPreloaded =
                            newOrderData.OrderStatus !=
                            currOrderData.OrderStatus;
                        newOrderData.orderDiffs.diffTerminal =
                            newOrderData.TerminalID != currOrderData.TerminalID;
                        newOrderData.orderDiffs.diffStation =
                            newOrderData.StationID != currOrderData.StationID;
                        newOrderData.orderDiffs.diffCustomer =
                            newOrderData.CustomerID != currOrderData.CustomerID;
                        newOrderData.orderDiffs.diffSupplier =
                            newOrderData.SupplierID != currOrderData.SupplierID;
                        newOrderData.orderDiffs.diffLoadingNumber =
                            newOrderData.LoadingNumber !=
                            currOrderData.LoadingNumber;
                        newOrderData.orderDiffs.diffShipTo =
                            newOrderData.ShipTo != currOrderData.ShipTo;
                        newOrderData.orderDiffs.diffSpecialInstructions =
                            newOrderData.SpecialInstructions !=
                            currOrderData.SpecialInstructions;
                        newOrderData.orderDiffs.hasDiffs =
                            newOrderData.orderDiffs.diffLoadNum ||
                            newOrderData.orderDiffs.diffLoadNumOrd ||
                            newOrderData.orderDiffs.diffPreloaded ||
                            newOrderData.orderDiffs.diffTerminal ||
                            newOrderData.orderDiffs.diffStation ||
                            newOrderData.orderDiffs.diffCustomer ||
                            newOrderData.orderDiffs.diffSupplier ||
                            newOrderData.orderDiffs.diffLoadingNumber ||
                            newOrderData.orderDiffs.diffShipTo ||
                            newOrderData.orderDiffs.diffSpecialInstructions;
                        newOrderData.orderDiffs.hasPrdDiffs = false;
                        if (!thereAreDiffs) {
                            thereAreDiffs = newOrderData.orderDiffs.hasDiffs;
                        }

                        // Product Diffs
                        for (
                            let newPrd = 0;
                            newPrd < newPrdData.length;
                            newPrd++
                        ) {
                            for (
                                let currPrd = 0;
                                currPrd < currPrdData.length;
                                currPrd++
                            ) {
                                if (
                                    newPrdData[newPrd].ProductID ==
                                        currPrdData[currPrd].ProductID &&
                                    newPrdData[newPrd].ProductCode ==
                                        currPrdData[currPrd].ProductCode &&
                                    newPrdData[newPrd].Product ==
                                        currPrdData[currPrd].Product
                                ) {
                                    currPrdData[currPrd].IsMatch = true;
                                    newPrdData[newPrd].diffDispatchedQuantity =
                                        newPrdData[newPrd].DispatchedQuantity !=
                                        currPrdData[currPrd].DispatchedQuantity;
                                    if (!thereAreDiffs) {
                                        thereAreDiffs =
                                            newPrdData[newPrd]
                                                .diffDispatchedQuantity;
                                    }
                                    if (!newOrderData.orderDiffs.hasPrdDiffs) {
                                        newOrderData.orderDiffs.hasPrdDiffs =
                                            newPrdData[
                                                newPrd
                                            ].diffDispatchedQuantity;
                                    }
                                    newOrdShData[
                                        newOrd
                                    ].MatchingProductData.push({
                                        Current: currPrdData[currPrd],
                                        New: newPrdData[newPrd]
                                    });
                                    break;
                                }

                                if (currPrd == currPrdData.length - 1) {
                                    newOrdShData[
                                        newOrd
                                    ].OnlyNewProductData.push(
                                        newPrdData[newPrd]
                                    );
                                    newOrderData.orderDiffs.hasPrdDiffs = true;
                                    if (!thereAreDiffs) {
                                        thereAreDiffs = true;
                                    }
                                }
                            }
                        }

                        newOrdShData[
                            newOrd
                        ].OnlyCurrentProductData = currPrdData.filter(
                            prd => prd.IsMatch != true
                        );
                        if (
                            newOrdShData[newOrd].OnlyCurrentProductData
                                .length !== 0
                        ) {
                            newOrderData.orderDiffs.hasPrdDiffs = true;
                            if (!thereAreDiffs) {
                                thereAreDiffs = true;
                            }
                        }

                        //this.OrderData.push({ "Current":  currOrdShData[currOrd], "New": newOrdShData[newOrd] });
                        matchingOrders.push(
                            currOrdShData[currOrd].generalOrderData.OrderID
                        );
                        break;
                    }

                    if (currOrd == currOrdShData.length - 1) {
                        //this.OrderData.push({ "Current": false, "New":  newOrdShData[newOrd] });
                        if (!thereAreDiffs) {
                            thereAreDiffs = true;
                        }
                    }
                }
            }

            // Check that matchingOrders is empty
            if (matchingOrders.length == 0) {
                /*for (let ord of currOrdShData) {
                    this.OrderData.push({ "Current": ord, "New": false });
                }*/
                if (!thereAreDiffs) {
                    thereAreDiffs = true;
                }
            } else {
                for (let ord = 0; ord < currOrdShData.length; ord++) {
                    for (
                        let ordId = 0;
                        ordId < matchingOrders.length;
                        ordId++
                    ) {
                        if (
                            currOrdShData[ord].generalOrderData.OrderID ==
                            matchingOrders[ordId]
                        ) {
                            break;
                        } else if (ordId == matchingOrders.length - 1) {
                            //this.OrderData.push({ "Current": currOrdShData[ord], "New": false });
                            if (!thereAreDiffs) {
                                thereAreDiffs = true;
                            }
                        }
                    }
                }
            }

            if (thereAreDiffs) {
                this.filteredDriverShifts[index].ColorSTDBtn = '#ceb500';
            } else {
                this.filteredDriverShifts[index].ColorSTDBtn = '#4f83cc';
            }

            this.updatePendingRevises(index, thereAreDiffs);
        },
        
        updatePendingRevises: async function(index, thereAreDiffs) {
            console.log(thereAreDiffs);
            var str = this.$store;
            let shDetail =  this.filteredDriverShifts[index];
            let params = {
                ShiftDetail: shDetail,
                PendingRevises: thereAreDiffs ? 1 : 0
            };

            await axios
                .put('shift-detail/pending-revises', params)
                .then(async response => {
                    console.log(response.data);
                    //this.loadShifts(true);
                })
                .catch(function(error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        
        async getOrdersByShiftDetail(instruction) {
            var str = this.$store;
            this.loadProgress = true;
            let orders ;
            if (instruction == 'just-refresh') {
                str.dispatch('setSnackbar', {
                    color: '#1F618D',
                    text: 'Refreshing orders...'
                });

                this.loadProgress = false;
            } else if (instruction == 'synchronization') {
                if (this.shift?.driver?.Name !== '') {
                    this.syncMessage = [
                        `${this.shift.driver.Name}`,
                        ' has progressed in his Shift.',
                        'Your actions will not be executed.',
                        'Try it again after synchronization.',
                        'Synchronizing data with Eleos App...'
                    ];
                    this.$store.state.dispatch.syncWarning = true;
                    this.loadProgress = false;
                }
            }
            await axios
                .post('order/shift/new/' + this.$store.state.removeOrderShift)
                .then(response => {
                    orders = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                    orders = [];
                    this.loadProgress = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something went wrong. Please contact IT Support.'
                    });
                });
            return orders;
        },
    }
};
</script>
